import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-form-number-indicator',
    templateUrl: './form-number-indicator.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
})
export class FormNumberIndicatorComponent {
    @Input() formFieldNumber: string | undefined;
}
